import {
  BasePageMetaResolver,
  CategoryPageMetaResolver,
  CmsService,
  ProductSearchService,
  TranslationService,
  WindowRef
} from '@spartacus/core'
import { Injectable } from '@angular/core'
import { MbBasePageMetaResolver } from '../../cms/page/mb-base-page-meta-resolver'

@Injectable({
  providedIn: 'root'
})
export class MiltenyiCategoryPageMetaResolver extends CategoryPageMetaResolver {

  constructor (productSearchService: ProductSearchService,
               cms: CmsService,
               translation: TranslationService,
               basePageMetaResolver: BasePageMetaResolver,
               protected mbBasePageMetaResolver: MbBasePageMetaResolver,
               protected winRef: WindowRef) {
    super(productSearchService, cms, translation, basePageMetaResolver)
  }

  resolveRobots () {
    return this.mbBasePageMetaResolver.resolveRobots()
  }
}
